// Lib
import { mapValues, curry } from 'lodash';

export default curry((combiningFn, obj1, obj2) =>
    mapValues(obj2, (val1, property) => combiningFn(val1, obj1[property])),
);
